import gpxPoly from './poly.gpx';

export type Objective = {
    lng: number;
    lat: number;
    id: string;
    name: string;
    description: string;
    solutions: string[];
    special?: boolean;
};

type ObjectiveRaw = Omit<Objective, 'lng' | 'lat'> & {
    lng?: number;
    lat?: number;
    loc?: string;
};

function parseMapyCzString(locString: string): { lng: number; lat: number } {
    // 49.5533600N, 15.3443378E
    if (locString === "TODO") {
        return {
            lng: 0,
            lat :0,
        };
    }
    const split = locString.split(',');
    const processed = split.map(x => x.trim()).map(x => x.substring(0, x.length - 1));
    return {
        lng: parseFloat(processed[1]),
        lat: parseFloat(processed[0]),
    };
}

function parseMapyCzPolygon(mapycz: string[]): [number, number][] {
    const poly: [number, number][] = [];
    for (const str of mapycz) {
        const coords = parseMapyCzString(str);
        poly.push([coords.lng, coords.lat]);
    }
    poly.push(poly[0]);
    return poly;
}

function processObjectives(raw: ObjectiveRaw[]): Objective[] {
    const objs: Objective[] = [];
    for(const r of raw) {
        let coords;
        if (r.loc) {
            coords = parseMapyCzString(r.loc);
        } else if (r.lng !== undefined && r.lat !== undefined) {
            coords = {
                lng: r.lng,
                lat: r.lat,
            };
        } else {
            throw new Error("Objective lacks coordinates.");
        }
        objs.push({
            ...r,
            lng: coords.lng,
            lat: coords.lat,
        });
    }
    objs.sort((a, b) => b.lat - a.lat);
    let giveId = 1;
    for (const o of objs) {
        if (!o.name.toLowerCase().startsWith("todo")) {
            continue;
        }
        o.name = (giveId++).toString();
    }
    return objs;
}

function parseGpx(gpx: string): [number, number][] {
    const points: [number, number][] = [];
    const parser = new DOMParser();
    const doc = parser.parseFromString(gpx, "application/xml");
    const root = doc.children[0];
    for (const child of root.children) {
        points.push([
            parseFloat(child.getAttribute("lon")),
            parseFloat(child.getAttribute("lat")),
        ]);
    }
    points.push(points[0]);
    return points;
}

type GeoJsonLine = {
    'type': 'geojson',
    'data': {
        'type': 'FeatureCollection',
        'features': {
            'type': 'Feature',
            'geometry': {
                'type': 'LineString',
                'coordinates': [number, number][]
            },
            'id': number,
            'properties': {},
        }[],
    },
};

export const gamePolygon: GeoJsonLine = {
    type: "geojson",
    data: {
        type: "FeatureCollection",
        features: [
            {
                type: "Feature",
                id: 0,
                geometry: {
                    type: "LineString",
                    coordinates: parseGpx(gpxPoly),
                },
                properties: {},
            },
        ],
    },
};

//////////////////////////////////
// Define game objectives here! //
//////////////////////////////////
const objectivesRaw: ObjectiveRaw[] = [
    {
        loc: "49.5962797N, 15.2893239E",
        id: "objekt",
        name: "Cíl",
        description: "Tady je naše tajná základna. Sem přijďte. Lokaci neprozrazujte jiným tří- ani čtyřpísmenkovým organizacím.",
        solutions: [
            "",
        ],
        special: true,
    },
    //
    // Kubovy
    //
    {
        loc: "49.5421228N, 15.3536864E",
        id: "eva_skola",
        name: "TODO",
        description: "Dle našich informátorů se zde nachází výcvikové zařízení jiné třípísmenkové organizace. Prověřte.<br><br>Hledáte první slovo velkého nápisu ve formátu \"[heslo] škola\"",
        solutions: [
            "Evanjelická",
            "Evangelická",
        ],
    },
    {
        loc: "49.5633331N, 15.3378906E",
        id: "brunka_sklad",
        name: "TODO",
        description: "V této oblasti byl zjištěn sklad vojenského materiálu. Zjistěte, co se zde skladuje.",
        solutions: [
            "Hračky",
            "Hraček",
            "Darovánek",
        ],
    },
    {
        loc: "49.5659764N, 15.3325183E",
        id: "brunka_rybnik",
        name: "TODO",
        description: "Zde se zřejmě nachází výzkumné hydroponické zařízení. Zjistěte jeho šestimístné číslo revíru.",
        solutions: [
            "421057",
            "421 057",
        ],
    },
    {
        loc: "49.5662311N, 15.3392139E",
        id: "brunka_vcely",
        name: "TODO",
        description: "Toto místo je zamořeno nebezpečným biologickým materiálem, který při kontaktu s kůží způsobuje podráždění a v krajních případech smrt. Zjistěte, o jaký materiál se jedná.",
        solutions: [
            "Včely",
            "Úl",
            "Úly",
            "Včelstvo",
            "Včelstva",
            "Med",
        ],
    },
    {
        loc: "49.5686981N, 15.3443650E",
        id: "brunka_kriz",
        name: "TODO",
        description: "Kříž v tomto místě byl znesvědcen znamením cizí třípísmenkové organizace. Zjistěte, o jakou organizaci se jedná.",
        solutions: [
            "KČT",
            "Klub českých turistů",
        ],
    },
    {
        loc: "49.5633686N, 15.3455944E",
        id: "vodnik",
        name: "TODO",
        description: "Místní narkogangy v tomto místě vybudovaly sochu propagující užívání návykových látek. Zjistěte, o jakou látku se jedná.",
        solutions: [
            "Tabák",
            "Tabáky",
            "Nikotin",
            "Kouření",
            "Cigareta",
            "Cigarety",
            "Dýmka",
            "Dýmky",
            "Fajfka",
            "Fajfky",
            "Vodník",
            "Vodnice",
            "Vodní dýmka",
        ],
    },
    {
        loc: "49.5580131N, 15.3484739E",
        id: "technicke_sluzby",
        name: "TODO",
        description: "Provozovatel objekt na tomto místě vybavil špionážním zařízením. Z brány objektu zjistěte prostřední trojčíslí telefonního čísla provozovatele.",
        solutions: [
            "397",
        ],
    },
    {
        loc: "49.5539178N, 15.3518925E",
        id: "kanal_se_sipkou",
        name: "TODO",
        description: "Zjistěte, jakou barvou je nakreslena šipka na záložním vstupu do podzemního objektu, který se zde nachází.",
        solutions: [
            "Oranžová",
            "Oranžově",
            "Oranžovou",
            "Růžová",
            "Růžově",
            "Růžovou",
        ],
    },
    {
        loc: "49.5520031N, 15.3541181E",
        id: "pesina_pres_potom",
        name: "TODO",
        description: "V tomto místě se nachází improvizovaný přechod přes vodní tok. Zjistěte, z jakého materiálu byl vybudován.",
        solutions: [
            "Dřevo",
            "Dřeva",
            "Prkno",
            "Prkna",
            "Paleta",
            "Palety",
        ],
    },
    {
        loc: "49.5514161N, 15.3557747E",
        id: "slepa_ulicka_lampa",
        name: "TODO",
        description: "Zjistěte spodní trojčíslí čísla lampy v tomto místě.",
        solutions: [
            "027",
        ],
    },
    {
        loc: "49.5465286N, 15.3554239E",
        id: "lampa_sireny",
        name: "TODO",
        description: "Lampa v tomto místě je vybavena výstražným zařízením. Zjistěte, kolik reproduktorů je na ni namontováno.",
        solutions: [
            "3",
        ],
    },
    {
        loc: "49.5430931N, 15.3563381E",
        id: "hydrant_park_stromovka",
        name: "TODO",
        description: "Zde se nachází zanedbané zařízení požární ochrany. Zjistěte datum poslední kontroly.<br><br>Zadejte ho ve formátu MM/YYYY.",
        solutions: [
            "05/2019",
            "5/2019",
            "5/19",
            "05/19",
            "Květen/2019",
            "Květen/19",
        ],
    },
    {
        loc: "49.5424203N, 15.3562733E",
        id: "sidliste_kamen_eu",
        name: "TODO",
        description: "V tomto místě byl realizován projekt, který byl financován jistou dvoupísmenkovou organizací. Zjistěte první slovo názvu tohoto projektu.",
        solutions: [
            "Regenerace",
        ],
    },
    {
        loc: "49.5408039N, 15.3570078E",
        id: "cerne_zachody",
        name: "TODO",
        description: "V těchto místech se nachází záhadný krychlový objekt černé barvy, který patrně patří jisté dvoupísmenkové organizaci. Zjistěte, o jakou organizaci se jedná.",
        solutions: [
            "WC",
        ],
    },
    {
        loc: "49.5403614N, 15.3555406E",
        id: "hotel_fabrika",
        name: "TODO",
        description: "Bylo zde zjištěno ubytovací zařízení cizí třípísmenkové organizace. Z obelisku před zařízením zjistěte, o jakou organizaci se jedná.",
        solutions: [
            "MHA",
        ],
    },
    {
        loc: "49.5408231N, 15.3532361E",
        id: "motoservis",
        name: "TODO",
        description: "Podle našich informátorů se zde nachází servisní zařízení vozidel, které patrně využívá cizí třípísmenková organizace. Zjistěte název tohoto servisu.<br><br>Heslo má 6 písmen.",
        solutions: [
            "Kašpar",
        ],
    },
    {
        loc: "49.5388550N, 15.3547533E",
        id: "pojistovna_generali",
        name: "TODO",
        description: "V těchto místech je centrála organizovaného zločinu, která se zvenku tváří jako kancelář s červeným polepem oken. Zjistěte, co \"klidného\" zdánlivě zajišťují svým zákazníkům.",
        solutions: [
            "Budoucnost",
        ],
    },
    {
        loc: "49.5379964N, 15.3553969E",
        id: "maryska_svitidla",
        name: "TODO",
        description: "V těchto místech se nachází cedule propagující podnik, který mimo jiné dodává elektrická zařízení, bez kterých se žádná armáda neobejde. Zjistěte první slovo názvu tohoto podniku.<br><br>Heslo má 7 písmen.",
        solutions: [
            "Maryška",
        ],
    },
    {
        loc: "49.5364414N, 15.3576011E",
        id: "reality_rezidence_na_kalvarii",
        name: "TODO",
        description: "V těchto místech se údajně nachází reklama na reality. Dle našich informátorů je možné, že osoba v levé části reklamy je agentem cizí třípísmenkové organizace. Zjistěte její příjmení.",
        solutions: [
            "Fišer",
        ],
    },
    {
        loc: "49.5369928N, 15.3543478E",
        id: "hydrant_sidliste",
        name: "TODO",
        description: "Zde se nachází zanedbané zařízení požární ochrany. Zjistěte rok poslední kontroly.",
        solutions: [
            "2017",
        ],
    },
    {
        loc: "49.5380842N, 15.3516367E",
        id: "jakasi_elektrika",
        name: "TODO",
        description: "Zde se nachází elektrické rozvodné zařízení. Zjistěte jeho kód S0*****.",
        solutions: [
            "19947",
            "S019947",
            "SO19947",
        ],
    },
    {
        loc: "49.5402458N, 15.3523839E",
        id: "jakysi_sprej",
        name: "TODO",
        description: "Toto místo si označila cizí třípísmenková organizace. Zjistěte, o jakou třípísmennou organizaci se jedná.<br><br>Hledejte modrý nápis zezadu v dolní části zídky.",
        solutions: [
            "ZNK",
            "SNK",
            "INK",
            "2NK",
        ],
    },
    {
        loc: "49.5412817N, 15.3508631E",
        id: "vbrance_zakaz",
        name: "TODO",
        description: "V těchto místech se nachází cedule s rudým mezikružím. Zjistěte, co je na ní napsáno.<br><br>Heslo je prostřední slovo na třetím řádku od konce.",
        solutions: [
            "Povolen",
        ],
    },
    //
    // Standa
    //
    {
        loc: "49.5432219N, 15.3501825E",
        id: "eon_bazmek",
        name: "TODO_vyplnit_později",
        description: "Jistá třípísmenková organizace zde má svou provozovnu číslo 10017596. Zjistěte, o kterou organizaci se jedná.",
        solutions: [
            "EON",
            "E.ON",
            "E-ON",
        ],
    },
    {
        loc: "49.5438847N, 15.3473258E",
        id: "hriste",
        name: "TODO_vyplnit_později",
        description: "Zde se nachází rekreační zařízení \"Humpolec - Na Skalce - sportovní\" s podezřele specifickými pravidly. Zjistěte, co je zde explicitně povoleno dělat.",
        solutions: [
            "vstupovat na trávníky",
            "vstupovat na trávník",
            "vstupovat na trávu",
        ],
    },
    {
        loc: "49.5443294N, 15.3435194E",
        id: "necti_a_zdrhej",
        name: "TODO_vyplnit_později",
        description: "Jistá paramilitární organizace zde v kotcích trénuje bojového psa. Zjistěte jeho jméno, uvedené velkými tiskacími písmeny na ceduli na brance.",
        solutions: [
            "Zdrhej",
            "Zdrhej!!!",
            "Zdrhej !!!",
            "Nečti a zdrhej",
            "Nečti a zdrhej!!!",
            "Nečti a zdrhej !!!",
        ],
    },
    {
        loc: "49.5407147N, 15.3472489E",
        id: "mor",
        name: "TODO",
        description: "V minulosti zde byly na místní populaci testovány biologické zbraně. Zjistěte, kdo nechal zhotovit památník na tento incident.",
        solutions: [
            "Josef Nápravník",
            "Nápravník",
            "Josef",
        ],
    },
    {
        loc: "49.5419047N, 15.3516311E",
        id: "garazove_zvedaky",
        name: "TODO_vyplnit_později",
        description: "V tomto objektu sídlí klíčový dodavatel zvedáků na bojová vozidla. Zjistěte faxové číslo.",
        solutions: [
            "565 533982",
            "565 533 982",
            "565533982",
        ],
    },
    {
        loc: "49.5722564N, 15.3427400E",
        id: "kriz_prazdny",
        name: "TODO_vyplnit_později",
        description: "Nápis v bílém rámu na tomto kříži využívá jiná třípísmenková organizace jako tajné heslo. Zjistěte, co je zde napsáno.",
        solutions: [
            "Nic",
            "null",
            "undefined",
            "?",
            "prázdnota",
            "prázdno",
            "prázdné",
            "prázdný",
            "prázdná",
            "",
            "\"\"",
            "''",
        ],
    },
    {
        loc: "49.5684583N, 15.3456972E",
        id: "vrak",
        name: "TODO_vyplnit_později",
        description: "Opuštěné vozidlo na tomto místě využívají místní gangy jako drop point ilegálních chemických látek. Zjistěte nápis na velkém kanystru v kufru vozidla.",
        solutions: [
            "Krystal WC",
            "Krystal",
        ],
    },
    {
        loc: "49.5684458N, 15.3519456E",
        id: "truhlarstvi",
        name: "TODO_vyplnit_později",
        description: "V těchto místech má stanoviště agent s krycím jméném \"Truhlář\". Zjistěte jeho celé skutečné jméno.",
        solutions: [
            "Antonín Moravec",
        ],
    },
    //
    // Lukáš
    //

    {
        loc: "49.5390106N, 15.3579083E",
        id: "ca_humpolec",
        name: "TODO_vyplnit_později",
        description: "Zde se nachází neonacistický podnik s iniciálami HH. Zjistěte obě slova jeho názvu.",
        solutions: [
            "Hliník Humpolec",
        ],
    },
    {
        loc: "49.5412608N, 15.3603842E",
        id: "polygraf_studio",
        name: "TODO_vyplnit_později",
        description: "Naše organizace potřebuje zprovoznit polygraf. Zjistěte telefonní číslo kontaktní osoby, která by nám v tom mohla pomoci.",
        solutions: [
            "734 649 479",
            "734649479",
        ],
    },
    {
        loc: "49.5391203N, 15.3616239E",
        id: "kostel_tolerancni",
        name: "TODO_vyplnit_později",
        description: "V tomto kostele se od roku 2012 konají podezřelé aktivity. Která organizace je pořádá?",
        solutions: [
            "Zichpil",
            "Skanzen Zichpil",
        ],
    },
    {
        loc: "49.5444147N, 15.3572992E",
        id: "kruhac",
        name: "TODO_vyplnit_později",
        description: "Místní kruhový objezd má podezřelé omezení pro vozidla od specifické délky. Zjistěte tuto délku v metrech.",
        solutions: [
            "12",
            "12m",
            "12 m",
            "12 metrů",
        ],
    },
    {
        loc: "49.5600329N, 15.3355812E",
        id: "trdlo_antena",
        name: "TODO_vyplnit_později",
        description: "Na rybníku Trdlo je umístěna tajná 160 m dlouhá středovlnná anténa, maskovaná jako zařízení rybníka. O jaké zařízení se podle cedule jedná?",
        solutions: [
            "rozmrazovač",
        ],
    },
    {
        loc: "49.5518981N, 15.3276580E",
        id: "silo",
        name: "TODO_vyplnit_později",
        description: "Donesly se nám zprávy o existenci prototypu nové mezikontinentální balistické rakety D-1 (čteno D eins). Jaké označení se zde používá pro raketové silo, v němž je připravena?",
        solutions: [
            "kanalizace",
            "šachta",
            "kanalizace - D1",
            "šachta 2",
        ],
    },
    {
        loc: "49.5503664N, 15.3313725E",
        id: "humpo_rybnik",
        name: "TODO_vyplnit_později",
        description: "V umělé vodní nádrži zvané prostě „Humpolecký rybník“ nebo „Chovný rybník“ probíhá pokus o vyšlechtění bojových kaprů. Co považuje armáda za největší riziko hrozící tomuto programu?",
        solutions: [
            "rybolov",
        ],
    },
    {
        loc: "49.5463536N, 15.3376650E",
        id: "trafo",
        name: "TODO_vyplnit_později",
        description: "V poslední době se rozmohly hackerské útoky proti transformátorovým cívkám (typicky využívající vulnerabilit v jejich webovém UI). Pro efektivní obranu je třeba znát jméno výrobce transformátorů instalovaných na místní trafostanici - zejména transformátoru T102. Jako obvykle, jde o 3 písmenka.",
        solutions: [
            "ETD",
            // random písmenka z okolních elektroskříněk atd
            "AVT",
            "AVT 2",
            "25 MVA",
            "MVA",
            // provozovatel rozvodny
            "EGD",
            "EG.D",
        ],
    },
    {
        loc: "49.5448889N, 15.3442922E",
        id: "blanicka_zahradni",
        name: "TODO_vyplnit_později",
        description: "V Humpolci vznikla nová, soukromá, třípísmenková agentura nabízející „komplexní služby“ - podle grafiky však jde zřejmě jen o low-tech 24/7 sledování. Jak se třípísmenková agentura jmenuje?",
        solutions: [
            "JRC",
            "JRC geodet",
            "JRCgeodet",
        ],
    },
    {
        loc: "49.5412686N, 15.3549786E",
        id: "posta",
        name: "TODO_vyplnit_později",
        description: "Místní pošta používá zajímavou taktiku pro zmatení nepřítele: „po uzavření této pošty je otevřena pošta“. Dohledejte vysvětlení tohoto paradoxu. Bude stačit krátký prefix vysvětlení přímo z cedule.",
        solutions: [
            "393 01",
            ":",
            "3",
            "39",
            "393",
            "39301",
            "393 01",
            "39301 Pelhřimov",
            "393 01 Pelhřimov",
            "jiná pošta",
            "jiná",
            "jinde",
            "Svatovítské",
            "Svatovítské Náměstí",
            "Svatovítské Náměstí 126",
            "393 01 Pelhřimov, Svatovítské Náměstí 126",
            "wtf",
        ],
    },
    // {
    //     loc: "49.5445050N, 15.3569312E",
    //     id: "zastavka_zakaz",
    //     name: "TODO_vyplnit_později",
    //     description: "Co je zakázáno na autobusové zastávce Kuchařov?",
    //     solutions: [
    //         "kouř",
    //         "kouře",
    //         "zákaz kouře",
    //         "kouřei",
    //         "kouře|",
    //     ],
    // },

	// Sejsel
	// 17 - Voiceguard Varovný a informační systém COLSYS, číslo 146 na sloupu
    {
        loc: "49.5658056N, 15.3557317E",
        id: "voiceguard",
        name: "TODO",
        description: "Na tomto místě je instalován podezřelý systém šesti(!!)-písmenkovou organizací. Zjistěte identifikační číslo tohoto systému.",
        solutions: [
            "146",
        ],
    },
	// 19 - kanál voda nápis HAWLE
	// 30 - MCMXXI \n MCMLXXIV na domě
	// 43 - jízdní řád 1997-1998
    {
        loc: "49.5608456N, 15.3598928E",
        id: "autobus_hadina",
        name: "TODO",
        description: "Dle našich záznamů zde organizace ICOM prováděla v 7:39 transport nadějných budoucích agentů do výcvikového střediska v Humpolci (avšak pouze ve dnech školního vyučování). V kterém roce to bylo?",
        solutions: [
            "1997-1998",
            "97",
            "98",
            "98-98",
            "1997",
            "1998",
            "1997 - 1998",
            "1997,1998",
            "1997, 1998",
        ],
    },
	// 48 - BIOLOGICKÝ RYBNÍK ZÁKAZ VSTUPU
	// 59/60 - cedulka POCHOD KČT a šipka
	// 73-77 - tyč (čichačka), nálepky:
	// 16/17 17/18 17/18 - růžová
	// 19/20 - růžová
	// 21/22 - modrá
	// 22/23 - červená
	// 22/23 - červená
    {
        loc: "49.5578117N, 15.3649725E",
        id: "cichacka",
        name: "TODO",
        description: "V této oblasti se nachází zařízení, které dle záznamů bývalo kontrolováno maximálně jednou za rok. V kterém roce došlo k jeho poslední kontrole?",
        solutions: [
            "2023",
            "23",
        ],
    },
	// cedulky stromů (87-)
	// 95 - zákaz vstupu na led
	// 101 - překvapivě těžká ryba (sežrala pistoli?) 78cm - 10.3kg
	// 107
    {
        loc: "49.5562867N, 15.3629944E",
        id: "rybnik_hadina",
        name: "TODO",
        description: "Dne 6. 6. 2026 zde MO ČRS Humpolec organizuje akci. Které zvíře zde můžeme vyhrát?",
        solutions: [
            "100kg prase",
            "prase",
            "100 kg prase",
        ],
    },
	// 117 - Třípísmenková akční skupina MAS
	// 151 - Třípísmenková organizace ČZU vyučuje chov koní
	// 152 - Rychlá pomoc při likvidaci (kovového odpadu)
    {
        loc: "49.5496486N, 15.3646183E",
        id: "likvidace",
        name: "TODO",
        description: "V této oblasti inzeruje čtyřpísmenná organizace, která nabízí rychlou pomoc při likvidaci. O kterou organizaci se jedná?",
        solutions: [
            "FAST",
            "FAST kovošrot",
            "kovošrot",
        ],
    },
	// 174 - Česká zemědělská akademie (oprava aut, karosářská práce, nástřík spodní části aut)
	// 179 - Výrobce zařízení pro povrchové úpravy
	// 175 - Šimčíkovi zde nebydlí, Vítkovi
    {
        loc: "49.5470208N, 15.3586575E",
        id: "rename",
        name: "TODO",
        description: "V této oblasti sídlí agent Šimčík. V důsledku zpackané operace musel změnit identitu. Jaké nové příjmení používá?",
        solutions: [
            "Vítek",
            "Vítkov",
            "Vítkovi",
        ],
    },
	
    
    //
    // TODO další
    //

    // {
    //     loc: "TODO",
    //     id: "TODO",
    //     name: "TODO_vyplnit_později",
    //     description: "TODO",
    //     solutions: [
    //         "TODO",
    //     ],
    // },
] as const;

export const requiredObjectiveCount = 12; // TODO

export const objectives: Objective[] = processObjectives(objectivesRaw);
